import { TState } from '../common/types';

export const initialState: TState = {
  loading: true,
};
